import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function SectionWho() {
  const { t } = useTranslation();

  // 文案内容对象
  const contentData = {
    title: t('CAM_WHO_TITLE'),
    cards: [
      {
        id: 'cam-performers',
        icon: '🔞',
        title: t('CAM_WHO_CARD_CAM_PERFORMERS_TITLE'),
        description: t('CAM_WHO_CARD_CAM_PERFORMERS_DESC'),
      },
      {
        id: 'onlyfans-creators',
        icon: '💋',
        title: t('CAM_WHO_CARD_ONLYFANS_CREATORS_TITLE'),
        description: t('CAM_WHO_CARD_ONLYFANS_CREATORS_DESC'),
      },
      {
        id: 'content-sellers',
        icon: '🎥',
        title: t('CAM_WHO_CARD_CONTENT_SELLERS_TITLE'),
        description: t('CAM_WHO_CARD_CONTENT_SELLERS_DESC'),
      },
      {
        id: 'harassment-victims',
        icon: '🛡️',
        title: t('CAM_WHO_CARD_HARASSMENT_VICTIMS_TITLE'),
        description: t('CAM_WHO_CARD_HARASSMENT_VICTIMS_DESC'),
      },
    ],
  };
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{contentData.title}</h2>
      <div className={styles.cardsGrid}>
        {contentData.cards.map((card) => (
          <div key={card.id} className={styles.card}>
            <div className={styles.iconWrapper}>
              <span className={styles.icon}>{card.icon}</span>
            </div>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
